"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.number.constructor");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _auth = require("@/utils/auth");

var _vuex = require("vuex");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'Upload',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否启用媒体文件限制（图片10MB/JPG PNG、语音2MB/AMR≤60s、视频10MB/MP4、普通文件20MB、均需>5字节）
    strict: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data: function data() {
    return {
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      filePaths: [],
      imgUrls: [],
      fileList: [],
      // 正在上传中的文件数量（供父组件判断是否还有附件在传输中）
      uploadingCount: 0,
      dialogVisible: false,
      dialogImageUrl: ''
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['baseApi', 'filesUploadApi'])),
  methods: {
    // 计算当前文件上传进度百分比（0-100）
    uploadPercent: function uploadPercent(file) {
      if (!file || file.status === 'fail') {
        return 0;
      }

      var pct = Number(file.percentage);

      if (!isFinite(pct) || pct < 0) {
        return 0;
      }

      if (pct > 100) {
        return 100;
      }

      return Math.round(pct);
    },
    // 判断文件是否为图片
    isImage: function isImage(fileName) {
      var imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
      var fileExtension = fileName.substring(fileName.lastIndexOf('.'));
      return imgExtensions.includes(fileExtension.toLowerCase());
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      // 同一文件只记录一次，避免重复
      var itemStr = JSON.stringify(_objectSpread(_objectSpread({}, response), {}, {
        localName: file.name
      }));

      if (!this.filePaths.includes(itemStr)) {
        this.filePaths.push(itemStr);
      }

      if (!this.fileList.some(function (f) {
        return f.uid === file.uid;
      })) {
        this.fileList.push(file);
      }

      if (this.uploadingCount > 0) {
        this.uploadingCount--;
      }

      this.$emit('uploadSuccess', this.filePaths);
    },
    // 上传失败：释放上传计数（失败文件不会进入 filePaths）
    handleError: function handleError(err, file, fileList) {
      if (this.uploadingCount > 0) {
        this.uploadingCount--;
      }
    },
    clearImgs: function clearImgs() {
      this.filePaths = [];
      this.fileList = [];
    },
    setFileList: function setFileList(files) {
      var _this = this;

      this.filePaths = [];
      this.fileList = [];
      files.forEach(function (file) {
        if (file.realName) {
          _this.filePaths.push(JSON.stringify({
            realName: file.realName,
            url: file.url,
            type: file.type,
            alias: file.alias
          }));

          _this.fileList.push({
            name: file.alias || file.realName,
            url: file.url,
            response: {
              realName: file.realName,
              url: file.url,
              alias: file.alias
            }
          });
        }
      });
    },
    // 上传前校验入口：校验通过后记录“上传中”数量，供父组件保存时判断附件是否还在传输
    handleBeforeUpload: function handleBeforeUpload(file) {
      var _this2 = this;

      var result = this.validateFile(file);

      if (result === true) {
        this.uploadingCount++;
        return true;
      }

      if (result && typeof result.then === 'function') {
        // 异步校验（语音时长），通过后再计数
        return result.then(function (ok) {
          if (ok) {
            _this2.uploadingCount++;
          }

          return ok;
        });
      }

      return false;
    },
    // 上传前校验：仅当 strict=true 时启用媒体文件限制，其余页面保持原来的 100MB 限制
    // 规则：
    //  - 所有文件 size 必须大于 5 个字节
    //  - 图片（image）：10MB，支持 JPG、PNG 格式
    //  - 语音（voice）：2MB，播放长度不超过 60s，仅支持 AMR 格式
    //  - 视频（video）：10MB，支持 MP4 格式
    //  - 普通文件（file）：20MB
    validateFile: function validateFile(file) {
      // 非 strict 模式：保持原有逻辑，只限制 100MB
      if (!this.strict) {
        var isLt3M = file.size / 1024 / 1024 < 100;

        if (!isLt3M) {
          this.$message.error('上传文件大小不能超过 100MB!');
          return false;
        }

        return true;
      }

      var name = file.name || '';
      var ext = (name.lastIndexOf('.') > -1 ? name.substring(name.lastIndexOf('.') + 1) : '').toLowerCase(); // 1. 所有文件大小必须大于 5 个字节

      if (!file.size || file.size <= 5) {
        this.$message.error('文件「' + name + '」大小必须大于 5 个字节');
        return false;
      } // 2. 按扩展名归类并校验大小
      // 申请的图片只允许 JPG、PNG，其它图片格式一律不允许


      var IMAGE_ALLOWED = ['jpg', 'png']; // 常见图片扩展名（用于识别"是图片"）

      var IMAGE_EXTS_ALL = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico', 'tif', 'tiff', 'heic', 'heif', 'raw', 'psd', 'jfif'];
      var VOICE_EXTS = ['amr'];
      var VIDEO_EXTS = ['mp4'];
      var VOICE_UNSUPPORTED = ['mp3', 'wav', 'm4a', 'aac', 'wma', 'ogg', 'flac'];
      var VIDEO_UNSUPPORTED = ['avi', 'mov', 'mkv', 'wmv', 'flv', 'rmvb', 'webm', 'm4v']; // 判断是否为图片：扩展名属于常见图片格式，或 MIME 类型为 image/*

      var isImage = IMAGE_EXTS_ALL.includes(ext) || file.type && file.type.startsWith('image/');
      var maxBytes = 20 * 1024 * 1024;
      var typeLabel = '普通文件';

      if (isImage) {
        // 图片只允许 JPG、PNG，其它格式（jpeg/gif/webp/tif/heic 等）都不让传
        if (!IMAGE_ALLOWED.includes(ext)) {
          this.$message.error('图片仅支持 JPG、PNG 格式');
          return false;
        }

        maxBytes = 10 * 1024 * 1024;
        typeLabel = '图片';
      } else if (VOICE_EXTS.includes(ext)) {
        maxBytes = 2 * 1024 * 1024;
        typeLabel = '语音';
      } else if (VIDEO_EXTS.includes(ext)) {
        maxBytes = 10 * 1024 * 1024;
        typeLabel = '视频';
      } else if (VOICE_UNSUPPORTED.includes(ext)) {
        this.$message.error('语音仅支持 AMR 格式');
        return false;
      } else if (VIDEO_UNSUPPORTED.includes(ext)) {
        this.$message.error('视频仅支持 MP4 格式');
        return false;
      }

      if (file.size > maxBytes) {
        this.$message.error('文件「' + name + '」大小超过' + typeLabel + '限制（' + Math.round(maxBytes / 1024 / 1024) + 'MB）');
        return false;
      } // 3. 语音播放长度不超过 60s


      if (VOICE_EXTS.includes(ext)) {
        return this.checkVoiceDuration(file);
      }

      return true;
    },
    // 校验语音播放时长（不超过 60 秒）
    checkVoiceDuration: function checkVoiceDuration(file) {
      var _this3 = this;

      return new Promise(function (resolve) {
        var audio = new Audio();
        audio.preload = 'metadata';
        var objectUrl = URL.createObjectURL(file);

        audio.onloadedmetadata = function () {
          var duration = audio.duration;
          URL.revokeObjectURL(objectUrl); // 部分浏览器无法解析 AMR，duration 可能为 NaN/Infinity，此时不拦截

          if (isFinite(duration) && duration > 60) {
            _this3.$message.error('语音「' + file.name + '」播放时长不能超过 60 秒');

            resolve(false);
          } else {
            resolve(true);
          }
        };

        audio.onerror = function () {
          URL.revokeObjectURL(objectUrl);
          resolve(true);
        };

        audio.src = objectUrl;
      });
    },
    // 删除文件
    handleRemove: function handleRemove(file) {
      if (!file) return; // 删除的是“上传中”的文件：不会触发 success/error，需手动释放计数

      if (file.status === 'uploading' && this.uploadingCount > 0) {
        this.uploadingCount--;
      }

      var resp = file.response;
      var targetName = resp ? resp.realName : ''; // 上传中的文件没有 response，无法定位 filePaths，仅同步父组件状态避免报错

      if (!targetName) {
        this.$emit('delSuccess', this.filePaths);
        return;
      }

      this.filePaths = this.filePaths.filter(function (item) {
        try {
          var o = JSON.parse(item); // 保留：不匹配的项

          return o.realName !== targetName;
        } catch (e) {
          // 非法JSON也保留（或 return false 直接删除）
          return true;
        }
      }); // 从fileList中移除对应的文件对象

      this.fileList = this.fileList.filter(function (item) {
        return item.response && item.response.realName !== targetName;
      });
      this.$emit('delSuccess', this.filePaths);
    },
    // 下载文件
    downloadFile: function downloadFile(file) {
      var url = file.url;
      if (!url) return;
      var fileName = file.name || file.alias || file.realName || 'download'; // 先尝试 fetch + blob 下载，确保文件名可控

      fetch(url, {
        mode: 'cors'
      }).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        var blobUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }).catch(function () {
        window.open(url, '_blank');
      });
    }
  }
};
exports.default = _default;